/**
 * Users Services Module
 * Exports all user management services and factory functions
 */
// Service exports (export classes only, not internal response types)
export { AdminService } from './AdminService';
export { AuditService } from './AuditService';
export { AuthService } from './AuthService';
export { PresenceAnalyticsService, } from './PresenceAnalyticsService';
export { RightService } from './RightService';
export { RoleService } from './RoleService';
export { SystemHealthService } from './SystemService';
export { UserPreferencesService, } from './UserPreferencesService';
export { UserPushDeviceService, } from './UserPushDeviceService';
export { UserService } from './UserService';
// Service imports for factory
import { AdminService } from './AdminService';
import { AuditService } from './AuditService';
import { AuthService } from './AuthService';
import { PresenceAnalyticsService } from './PresenceAnalyticsService';
import { RightService } from './RightService';
import { RoleService } from './RoleService';
import { SystemHealthService } from './SystemService';
import { UserPreferencesService } from './UserPreferencesService';
import { UserPushDeviceService } from './UserPushDeviceService';
import { UserService } from './UserService';
/**
 * Create all user services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all user service instances
 */
export function createUsersServices(http, config) {
    return {
        admin: new AdminService(http, config),
        audit: new AuditService(http, config),
        auth: new AuthService(http, config),
        presenceAnalytics: new PresenceAnalyticsService(http, config),
        right: new RightService(http, config),
        role: new RoleService(http, config),
        system: new SystemHealthService(http, config),
        userPreferences: new UserPreferencesService(http, config),
        userPushDevice: new UserPushDeviceService(http, config),
        user: new UserService(http, config),
    };
}
//# sourceMappingURL=index.js.map